module.exports = __webpack_public_path__ + "static/media/20-points.7649ebd4.png";